import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface RtiTab {
  id: string;
  label: string;
}

interface RtiStat {
  label: string;
  value: string;
}

@Component({
  selector: 'app-register-page',
  templateUrl: './register-page.component.html',
  styleUrls: ['./register-page.component.scss']
})
export class RegisterPageComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  pageTitle = 'RTI Act';
  pageSubtitle =
    'Right to Information Act 2005 promotes transparency, accountability, and timely access to information in public authorities.';

 admissionNotice =
    'Admissions open for 2026 : B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS),B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,M.E. (CSE), M.E. (Embedded System Technologies),M.E. (Thermal Engineering), M.E. (Environmental Engineering)';
      
  tabs: RtiTab[] = [
    { id: 'tab1', label: 'RTI Act' }
  ];

  heroStats: RtiStat[] = [
    { label: 'Category', value: 'Public Information' },
    { label: 'Act', value: 'RTI Act 2005' },
    { label: 'Authority', value: 'Public Information Officer' },
    { label: 'Purpose', value: 'Transparency & Accountability' }
  ];

  rtiParagraphs: string[] = [
    'Right to Information Act 2005 mandates timely response to citizen requests for government information.',
    'The basic objective of the Right to Information Act is to empower the citizens, promote transparency and accountability in the working of the organizations defined as public authorities.',
    'All Universities and Colleges established by law made by Parliament or by State Legislature or by notification by the appropriate Government or owned, controlled or substantially financed directly or indirectly by funds provided by the Government shall come within the meaning of a Public Authority under this Act.',
    'In pursuance of the Right to Information Act 2005, the Principal has been designated as Public Information Officer (PIO) and will perform the duties and responsibilities as envisaged under the act without fail.'
  ];

  pioName = 'Dr. P. Nelson Raja, Principal.';
  pioEmail = 'principal@fmcet.ac.in';
  pioPhone = '+91 9942982321';

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'RTI Act';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  ngOnInit(): void {}
}